import { browserName } from 'react-device-detect';

export const isDevelop = (): boolean => {
  return process.env.REACT_APP_DEVELOPMENT === 'true';
};

export const isCoinbaseWallet = (): boolean => {
  return window.ethereum?.isCoinbaseWallet || window.ethereum?.isCoinbaseBrowser || false;
}; 

export const isMetamask = (): boolean => {
  return window.ethereum?.isMetaMask ?? false;
};

export const isMobile = (): boolean => {
  // Detecta dispositivos móviles basándose en las dimensiones de la pantalla
  return window.innerWidth <= 530;
};

export const isBrave = (): boolean => {
  return browserName === 'Brave' || browserName === 'brave';
};

export const isPhantom = (): boolean => {
  return window.solana?.isPhantom || window.phantom?.solana?.isPhantom || false;
};